import React, { useEffect } from 'react';
import MicroApp from '@/components/micro-app';
import env from '@/env';
import history from '@/history';

function DripworksInformationCenter() {
  useEffect(() => {
    const rawDefineProperty = Reflect.defineProperty;

    // 子应用的代码Object.defineProperty(window, '$queryParams', {get(), set()})多次执行
    // 第二次执行时会报错
    // 目前劫持Reflect.defineProperty发现定义的是$queryParams属性将其变为可配置
    Reflect.defineProperty = function (
      target: object,
      propertyKey: PropertyKey,
      attributes: PropertyDescriptor & ThisType<any>
    ) {
      if (propertyKey && propertyKey === '$queryParams' && attributes) {
        return rawDefineProperty.call(Reflect, target, propertyKey, { ...attributes, configurable: true });
      }
      try {
        return rawDefineProperty.call(Reflect, target, propertyKey, attributes);
      } catch (ex) {
        console.log('ex', ex);
      }

      return true;
    };

    return () => {
      Reflect.defineProperty = rawDefineProperty;
    };
  }, []);
  return (
    <MicroApp
      data={{ yxHistory: history, jingHaiLuLink: '/jinghailu', selectionLink: '/selection' }}
      destory
      name="informationCenter"
      url={`${env.INFORMATION_CENTER}`}
    />
  );
}

export default DripworksInformationCenter;
